import request from '@axios'

export function getFavicon(url) {
  return request({
    url: '/get-favicon',
    method: 'get',
    props: {url}
  })
}

export function selectData(data) {
  return request({
    url: '/select-data',
    method: 'post',
    data: data
  })
}